import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";
import Drawer from "components/Drawer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import EditConfiguration from "components/EditConfiguration";
import AddPharmacyConfig from "components/AddPharmacyConfig";
import ViewConfiguration from "components/ViewConfiguration";
import { onExport } from "utils/helper";
import ConfigurationTable from "../ConfigurationTable";
import SearchContainer from "../SearchContainerConfig";
import useContextService from "hooks/useContextService";
import AccmulatorTable from "../AccumulatorTable";
import useAxios from "hooks/useAxios";
import ConveredentityDetails from "../CoveredEntityDetails";
import AccmulatorDetails from "../AccmulatorDetails";
import Coveredentitytable from "../CoveredEntityDetailsTable";
import Loader from "components/Loader";

let filters = [];

const CoveredEntityConfig = (props) => {
  
  const {
    states: { configurations },
    setStates,
  } = useContextService();
  const { search, coveredEntity, searchTerms, claimStatusID } = configurations;
  const { orgId } = props;
  const API = useAxios();

  const [collapseSider, setcollapseSider] = useState(false);
  const [openPharmacy, setOpenPharmacy] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [editConfig, seteditconfig] = useState(false);
  const [viewConfig, setviewConfig] = useState(false);
  const [rowData, setRowData] = useState({});
  const[selectedAccumulator,setSelectedAccumulator]=useState([])
  const [data, setData] = useState([]);
  const [CEDid, setCEDId] = useState("");
  const [Cedata, setCEdata] = useState("");
  const [loading, setLoading] = useState(false);
  const [CEflag, setCEflag] = useState(false);
  const [ACCflag, setACCflag] = useState(false);
  const [AccumulatorTable, SetAccumulatorTable] = useState([]);
  const[configflag,setConfigFlag]=useState(false)
  const[CElevelflag,setCElevelflag]=useState(false)
const [resetFilterFlag, SetResetFilterFlag]= useState(false);
useEffect(()=>{
  setCEflag(false)
  setviewConfig(false)
  setACCflag(false)
  setCElevelflag(false)
},[orgId])


  useEffect(() => {
    fetchConfigurationTableData();
  }, []);
//   useEffect(()=>{
//     SetAccumulatorTable([])
//     setCEDId("")
//     setSelectedAccumulator([])
//     setCEdata("")
// setRowData({})

//   },[orgId])

  const manvalPharmacy = () => {
    setOpenPharmacy(!openPharmacy);
    fetchConfigurationTableData();
  };

  const manvalConfig = (rowData) => {
    setviewConfig(true);
    setRowData(rowData);
  };
  const manvalConfigedit = (rowData) => {
    setRowData(rowData);
    seteditconfig(!editConfig);
  };

  const handleExport = async () => {
    const { access_token } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/CPConfig/configuration/ConfigurationExportAll?access_token=${access_token}`;
    onExport(action, search);
  };

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  const fetchConfigurationTableData = async () => {
    debugger
    let organizationID = orgId?.organizationID;
    if (organizationID !== -1) {
      let selectedOrgId = orgId?.organizationID;
      const { token_type, access_token, profile } =
        JSON.parse(localStorage.getItem("pharmaforce")) || {};
      const { sub } = profile || {};
      setLoading(true);
      try {
        const { data } = await API.get(
          `SBConfig/coveredentity/list/${selectedOrgId}`,
          {
            hasDefaultURL: true,
          }
        );
        setData(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };
  const refetch = (check) => {
    if (check == true) {
      fetchConfigurationTableData();
    }
  };
  const onSearch = async (filter) => {
    debugger;

    const { CoveredEntityIDs, accumulationIds, ndc } = filter;
    console.log(filter, "filter");
    var ceIds = [];
    if (
      CoveredEntityIDs === undefined &&
      searchTerms.coveredEntityIDs.length !== undefined &&
      searchTerms.coveredEntityIDs.length > 0
    ) {
      ceIds = filter.coveredEntityIDs.map((item) => item["value"]);
      ceIds = searchTerms.coveredEntityIDs;
    } else {
      ceIds = CoveredEntityIDs;
    }

    // if(ceIds.length === 0){
    //   return true
    // }
     
    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    search.filters = filters;
    // handelAccumulator(search)
    //  search.ndc = filter.ndc
    // search.CoveredEntityIDs = ceIds;
    // console.log(tenantID, 'tenantid');
    // await fetchAccumulatorData(search);
  };
  const fetchcoveredentityDetails = async (CEID) => { 
    setLoading(true);
    try {
      const { data } = await API.get(
        `SBConfig/Configuration/CeRecord/${CEID?CEID:CEDid}`,
        {
          hasDefaultURL: true,
        }
      );
      console.log(data, "cedata");
      setCEdata(data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
    useEffect(()=>{
      if(CEDid){
          fetchcoveredentityDetails()
      }
    },[CEDid])

  return (
    <div>
      <div>
                    {/* {loading && <Loader opacity={0.02} color="black" />} */}

        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card className="border-0 shadow-top" hidden={(collapseSider==true || viewConfig==true)}>
            <CardBody>
              <SearchContainer
                onSearch={onSearch}
                orgId={orgId}
                onReset={""}
                setCEDId={setCEDId}
                CEDid={CEDid}
                fetchcoveredentityDetails={fetchcoveredentityDetails}
                CEflag={CEflag}
                setCEflag={setCEflag}
                viewConfig={viewConfig}
                setviewConfig={setviewConfig}
                setACCflag={setACCflag}
                ACCflag={ACCflag}
                setRowData={setRowData}
                rowData={rowData}
                AccumulatorTable={AccumulatorTable}
                SetAccumulatorTable={SetAccumulatorTable}
                setConfigFlag={setConfigFlag}
                configflag={configflag}
                setLoading={setLoading}
                loading={loading}
                resetFilterFlag = {resetFilterFlag}
                SetResetFilterFlag= {SetResetFilterFlag}
              />
            </CardBody>
          </Card>
        </div>
{/* 
        {CEflag == true  ? (
          <ConveredentityDetails
            Cedata={Cedata}
            CEflag={CEflag}
            setCEflag={setCEflag}
            collapseSider={collapseSider}
            toggleSider={toggleSider}
            SelectedAccumulator= {rowData.accumulatorID}
            setConfigFlag={setConfigFlag}
            configflag={configflag}
            rowData={rowData}
            orgId={orgId}
            
          />
        ) : (
          ""
        )} */}
            {CElevelflag == true || CEflag==true  ? (
          <ConveredentityDetails
            Cedata={Cedata}
            CEflag={CEflag}
            setCEflag={setCEflag}
            collapseSider={collapseSider}
            toggleSider={toggleSider}
            SelectedAccumulator= {rowData.accumulatorID}
            setConfigFlag={setConfigFlag}
            configflag={configflag}
            rowData={rowData}
            orgId={orgId}
            setCEDId={setCEDId}
            CEDid={CEDid}
            configlevel={true}
            setCElevelflag={setCElevelflag}
            CElevelflag={CElevelflag}
            viewConfig={viewConfig}
                setviewConfig={setviewConfig}
                setACCflag={setACCflag}
                setLoading={setLoading}
                loading={loading}
          />
        ) : (
          ""
        )}
        {CEflag==true? <Coveredentitytable Cedata={Cedata}
            CEflag={CEflag}
            rowData={rowData}
            orgId={orgId}
            setCEflag={setCEflag}
            collapseSider={collapseSider}
            toggleSider={toggleSider}
            SelectedAccumulator= {rowData.accumulatorID}
            setConfigFlag={setConfigFlag}
            setLoading={setLoading}
                loading={loading}
            configflag={configflag}/>:""}
        <div className={CEflag ? "mt-3" : "mb-0"} hidden={( CEflag==true|| viewConfig==true) }>
          <Card className="border-0 shadow-top p-0">
            <CardBody className="">
              <ErrorBoundary>
                <AccmulatorTable
                  rowData={rowData}
                  selectedAccumulator={selectedAccumulator}
                  setSelectedAccumulator={setSelectedAccumulator}
                  orgId={orgId}
                  setCEDId={setCEDId}
                  CEDid={CEDid}
                  manvalConfig={manvalConfig}
                  viewConfig={viewConfig}
                  toggleSider={toggleSider}
                  collapseSider={collapseSider}
                  setACCflag={setACCflag}
                   ACCflag={ACCflag}
                   AccumulatorTable={AccumulatorTable}
                   SetAccumulatorTable={SetAccumulatorTable}
                   setCElevelflag={setCElevelflag}
                   configlevel={true}
            CElevelflag={CElevelflag}
            setLoading={setLoading}
                loading={loading}
                resetFilterFlag = {resetFilterFlag}
                SetResetFilterFlag= {SetResetFilterFlag}
                />
                {/* <ConfigurationTable orgId={orgId} manvalPharmacy={manvalPharmacy}                toggleSider={toggleSider}
                collapseSider={collapseSider} manvalConfigedit={manvalConfigedit} manvalConfig={manvalConfig} onExport={handleExport} data={data} /> */}
              </ErrorBoundary>
            </CardBody>
          </Card>
        </div>
        {ACCflag==true?<AccmulatorDetails rowData={rowData} setACCflag={setACCflag} ACCflag={ACCflag}   viewConfig={viewConfig}
                setviewConfig={setviewConfig}        setLoading={setLoading}
                loading={loading}            setCElevelflag={setCElevelflag}
                
         CElevelflag={CElevelflag}/>
:""}
        {ACCflag == true  ? (
          <ViewConfiguration rowData={rowData} orgId={orgId} CEDid={CEDid}  setLoading={setLoading}
          loading={loading}/>
        ) : (
          ""
        )}
      
      </div>
      <Drawer
        direction="end"
        isOpen={openPharmacy}
        toggle={manvalPharmacy}
        size="lg"
        title="Add Covered Entity"
      >
        <AddPharmacyConfig
          openPharmacy={openPharmacy}
          manvalPharmacy={manvalPharmacy}
          orgId={orgId}
          refetch={refetch}
        />
      </Drawer>
      <Drawer
        direction="end"
        isOpen={editConfig}
        toggle={manvalConfigedit}
        size="lg"
        title="Edit Covered Entity"
      >
        <EditConfiguration
          rowData={rowData}
          manvalConfigedit={manvalConfigedit}
          editConfig={editConfig}
        />
      </Drawer>
      {/* <Drawer
                direction='end'
                isOpen={viewConfig}
                toggle={manvalConfig}
                size='lg'
                title='Configuration Details'
            >
                <ViewConfiguration rowData={rowData} orgId={orgId} />
            </Drawer> */}
    </div>
  );
};

export default CoveredEntityConfig;
